// Hook to dynamically update SEO meta tags per page (canonical, og:*, twitter:*)
// Resolves the "Detected, currently not indexed" issue in Google Search Console
// where all SPA routes share the same canonical URL from index.html.

import { useEffect } from "react";

const setMeta = (selector, attr, value) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("meta") ? "meta" : "link");
    // Parse selector to extract attribute name + value (e.g. meta[name="..."])
    const match = selector.match(/\[([^=]+)="([^"]+)"\]/);
    if (match) {
      el.setAttribute(match[1], match[2]);
    }
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export const usePageMeta = ({ title, description, url, image }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    if (url) {
      setMeta('link[rel="canonical"]', "href", url);
      setMeta('meta[property="og:url"]', "content", url);
    }
    if (image) {
      setMeta('meta[property="og:image"]', "content", image);
      setMeta('meta[name="twitter:image"]', "content", image);
    }
  }, [title, description, url, image]);
};
